export default __webpack_public_path__ + "2ecd5ca2ee7ed4a89d8f3a3db95509ef.svg";